import React from "react";
import AIService from "../components/AIService/AIService";

export default function AIServicePage(){
    return (
        <main>
          <AIService/>
        </main>
      );
    }
